import { Outlet } from '@tanstack/react-router';
import { useAllEngagementPostsQuery } from '@anytag/graphql';
import { ListWithPagination } from '@anytag/shared-molecules';
import { getOffset, getValuableVariables } from '@anytag/shared-utils';
import { useParamsSearch, useQueryHelper } from '@anytag/shared-hooks';
import { EngagementPostsList, EngagementPostsFilter, EngagementPostsSearchSchemaType } from '@anytag/shared-organisms';
import { useEngagementDetailsContext } from '../engagement-details-context';

export const EngagementPosts = () => {
  const { t, enqueueSnackbar } = useQueryHelper();
  const { engagement, engagementId, isOnlyTikTokTtcm } = useEngagementDetailsContext();
  const { page, limit, filter, setFilter } = useParamsSearch<EngagementPostsSearchSchemaType>();

  const { data, loading } = useAllEngagementPostsQuery({
    fetchPolicy: 'network-only',
    variables: getValuableVariables({
      limit,
      engagementId,
      keyword: filter.keyword,
      offset: getOffset(page, limit),
      status: filter.status || null
    }),
    onError: (error) => {
      enqueueSnackbar(t(error.message || 'Cannot get post list data'), { variant: 'error' });
    }
  });

  return (
    <ListWithPagination pagination={{ totalRecords: data?.allEngagementPostsCount?.totalNumber }}>
      <EngagementPostsFilter
        filter={filter}
        setFilter={setFilter}
        engagement={engagement}
        isOnlyTikTokTtcm={isOnlyTikTokTtcm}
      />
      <EngagementPostsList loading={loading} engagement={engagement} posts={data?.allEngagementPosts || []} />

      <Outlet />
    </ListWithPagination>
  );
};
